import Grid from '@mui/material/Unstable_Grid2';
import { WishlistResponse } from '@/types/gearApi/Wishlist';
import { ProductSearchResult } from '@/types/gearApi/Product';
import { createPriceLabel } from '@/utils/helpers/prices';
import ProductListingDictionary from '@/types/dictionaries/ProductListing';
import StockAvailabilityDictionary from '@/types/dictionaries/StockAvailability';
import { NormalizedLocale } from '@/enums/Locale';
import ProductCard from '../ProductCard';

interface ProductListProps {
	products: ProductSearchResult[];
	languageCode: NormalizedLocale;
	wishlists?: WishlistResponse;
	dict: ProductListingDictionary;
	isBusinessToBusinessShop: boolean;
	stockAvailabilityDict: StockAvailabilityDictionary;
	sharedCartId: string | null;
	requestQuoteUrl: string | null;
	contactUsUrl: string;
}

export default function ProductList({
	products,
	languageCode,
	wishlists,
	dict,
	stockAvailabilityDict,
	sharedCartId,
	isBusinessToBusinessShop,
	requestQuoteUrl,
	contactUsUrl,
}: Readonly<ProductListProps>) {
	return (
		<Grid container rowSpacing={3} columnSpacing={2} sx={{ paddingTop: '40px' }}>
			{products.map((item) => (
				<Grid key={item.id} xs={12} sm={6} md={3}>
					<ProductCard
						product={item}
						priceLabel={item.price ? createPriceLabel(item.price.value, item.price.currencyCode, languageCode) : undefined}
						wishlists={wishlists}
						dict={dict}
						stockAvailabilityDict={stockAvailabilityDict}
						sharedCartId={sharedCartId}
						isBusinessToBusinessShop={isBusinessToBusinessShop}
						requestQuoteUrl={requestQuoteUrl}
						contactUsUrl={contactUsUrl}
					/>
				</Grid>
			))}
		</Grid>
	);
}
